import type { FaireProductEntity } from "../../entity_types/product";

export const p_6222d74ugb: FaireProductEntity = {
  token: "p_6222d74ugb",
  type: "product",
  name: "LM-SW-1007 Light Blue/Grey Puff",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/eea70e863238612cce0ba11495b2226219a55a14c768e3d56c6603bd55ea4b29.jpeg",
  galleryImageUrls: [],
  priceDollars: 24.5,
  description: "This light blue and grey puff graphic sweatshirt from Girlie Girl Originals offers a casual, stylish layer with playful design details suited to wear. Designed for comfort and easy pairing, it updates your wardrobe with versatile appeal for weekends or casual outings.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:36.329Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
